import styled from 'styled-components';

import { MpParagraph } from 'shared/ui/MpParagraph';

const OlStyled = styled.ol`
	gap: 12px;
	display: flex;
	flex-direction: column;
	padding-left: 18px;
`;

const LiStyled = styled.li`
	margin: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

const SectionStyled = styled.section``;

const ImgStyled = styled.img`
	margin-bottom: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 446px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 446px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 446px;
	}
`;

export const FlashlightInstruction = (): JSX.Element => (
	<SectionStyled>
		<OlStyled>
			<LiStyled>Подключите бот через маркетплейс</LiStyled>
			<LiStyled>Перейдите к боту в Telegram</LiStyled>
			<LiStyled>Нажмите кнопку «Start», чтобы подписаться на уведомления</LiStyled>
			<LiStyled>Готово, ждите скорых новостей</LiStyled>
		</OlStyled>
		<MpParagraph>
			Добавьте бота в чат с вашими друзьями и отправьте команду <b>/start@dodo1000bot</b>, чтобы вместе радоваться
			каждому новому ресторану Dodo brands:
		</MpParagraph>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/flashlight/instruction-1' />
		<MpParagraph>Или открытию новой страны в сети:</MpParagraph>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/flashlight/instruction-2' />
	</SectionStyled>
);
